/* @flow */

export const TARGET_CLEARED: string = 'calendar@diffusion:TARGET_CLEAR';
export const TARGETS_UPDATED: string = 'calendar@diffusion:TARGETS_UPDATED';

export const updateTargets = targets => ({
  type: TARGETS_UPDATED,
  targets,
});

export const clearTarget = () => ({
  type: TARGET_CLEARED,
});



// WEBPACK FOOTER //
// ./src/modules/calendar/actions/diffusion.js